import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./about.css";
import teamImg from "../../images/team.png";

const AboutUsSection = () => {
  
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: false,
    });
    AOS.refresh();
  }, []);
  return (
    <section id="about">
      <div className="about-us-container">
        <div className="about-us-content">
          <div className="image-container" data-aos="fade-right">
            <img
              src={teamImg}
              alt="A team of three professionals smiling at the camera"
              className="team-image"
            />
          </div>
          <div className="text-content" data-aos="fade-left">
            {/* <div className="about-starter">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 256 256"
                className="about-icon"
              >
                <g opacity="0.2">
                  <path d="M168,100a60,60,0,1,1-60-60A60,60,0,0,1,168,100Z"></path>
                </g>
                <path d="M144,157.68a68,68,0,1,0-71.9,0c-20.65,6.76-39.23,19.39-54.17,37.17a8,8,0,0,0,12.25,10.3C50.25,181.19,77.91,168,108,168s57.75,13.19,77.87,37.15a8,8,0,0,0,12.25-10.3C183.18,177.07,164.6,164.44,144,157.68ZM56,100a52,52,0,1,1,52,52A52.06,52.06,0,0,1,56,100Zm197.66,33.66-32,32a8,8,0,0,1-11.32,0l-16-16a8,8,0,0,1,11.32-11.32L216,148.69l26.34-26.35a8,8,0,0,1,11.32,11.32Z"></path>
              </svg>
              <span className="about-subtitle">Sobre-nós</span>
            </div> */}

            <h2 className="feature-title">
              Uma equipa
              <div
              style={{width:'75%'}}>
                especializada
               {/* <svg className="underline-scratch" viewBox="0 0 60 10" preserveAspectRatio="none">
                <defs>
                  <filter id="pencilTextureUnderline">
                    <feTurbulence type="fractalNoise" baseFrequency="0.8" numOctaves="2" result="noise" />
                    <feDisplacementMap in="SourceGraphic" in2="noise" scale="1.5" />
                  </filter>
                </defs>
                <path d="M0 5 C15 7, 30 3, 60 5"
                  stroke="#ffb302a5"
                  troke-dasharray="4,2,1,3"
                  strokeWidth="2"
                  fill="transparent"
                  strokeLinecap="round"
                  filter="url(#pencilTextureUnderline)"
                />
                <path d="M0 5.3 C15 7.2, 30 3.2, 60 5.3"
                  stroke="#ffb302a5"
                  troke-dasharray="4,2,1,3"
                  strokeWidth="1.2"
                  fill="transparent"
                  strokeLinecap="round"
                  strokeOpacity="0.5"
                  filter="url(#pencilTextureUnderline)"
                />
                <path d="M0 4.8 C15 6.8, 30 2.8, 60 4.8"
                  stroke="#ffb302a5"
                  troke-dasharray="4,2,1,3"
                  strokeWidth="1"
                  fill="transparent"
                  strokeLinecap="round"
                  strokeOpacity="0.4"
                  filter="url(#pencilTextureUnderline)"
                />
              </svg> */}
              
              </div>
              
            </h2>
            <div className="description">
            <span>
                Somos uma empresa de gestão de </span>
                <span> Alojamento Local que colocaos </span>
                <span>teus objetivos em primeiro lugar.</span>
                <span>Sendo locais, oferecemos um</span>
                <span> serviço personalizado, profundo</span>
                <span>conhecimento do mercado e uma </span>
                <span>verdadeira paixão pela hospitalidade </span>
                <span>enraizada na nossa cultura</span>
                <span>portuguesa.</span>
            </div>
            <button className="learn-more-btn" onClick={() => {
            const el = document.getElementById("contacts");
            if (el) el.scrollIntoView({ behavior: "smooth" });
          }}>
            CONTACTE-NOS
          </button>
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default AboutUsSection;